const PORTAL_MODE_CONHECIMENTO = 'portal-conhecimento';
const PORTAL_MODE_INTEROPERABILIDADE = 'portal-interoperabilidade';

export const getPortalMode = () => process.env.MODE || process.env.REACT_APP_MODE || PORTAL_MODE_CONHECIMENTO;

export const isPortalInteroperabilidade = () => getPortalMode() === PORTAL_MODE_INTEROPERABILIDADE;

export const getPortalTitle = () => (
    isPortalInteroperabilidade()
        ? 'Portal da Interoperabilidade'
        : 'Portal do Conhecimento do Desenvolvedor'
);

/**
 * Monta o título de uma página, combinando o título específico da página
 * com o nome do portal. Quando nenhum título específico é informado,
 * retorna apenas o nome do portal.
 */
export const buildPageTitle = (pageSpecificTitle?: string) => {
    const portalTitle = getPortalTitle();
    return pageSpecificTitle
        ? `${pageSpecificTitle} | ${portalTitle}`
        : portalTitle;
};
